import React from 'react';
import SearchProducts from "../components/SearchProducts";


const SearchPage = () => {
    return (
        <React.Fragment >
            <SearchProducts />
        </React.Fragment>
    );
};

export default SearchPage;